import { Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimeDisplayFormat, useUpdateGeneralSettings } from '@/entities/settings';
import type { TimeDisplayFormat } from '@/entities/settings';
import { TimeDisplayFormatField } from './TimeDisplayFormatField';

type Props = {
  /** Изменение общих настроек доступно только с правом администрирования раздела */
  canEdit: boolean;
};

/**
 * Карточка раздела «Общее» с настройками отображения времени.
 * Свои данные и их сохранение держит сама: страница только размещает карточку.
 */
export const TimeSettingsCard: FC<Props> = ({ canEdit }) => {
  const { t } = useTranslation('generalSettings');
  const timeDisplayFormat = useTimeDisplayFormat();
  const { mutate: updateGeneralSettings, isPending } = useUpdateGeneralSettings();

  const handleTimeDisplayFormatChange = (value: TimeDisplayFormat) =>
    updateGeneralSettings({ timeDisplayFormat: value });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('timeSection')}</CardTitle>
      </CardHeader>
      <CardContent>
        <TimeDisplayFormatField
          value={timeDisplayFormat}
          disabled={!canEdit || isPending}
          onChange={handleTimeDisplayFormatChange}
        />
      </CardContent>
    </Card>
  );
};
